import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import BreadcrumbsItem from '../BreadcrumbsItem';
import { LAYOUT_LEVELS } from '../../constants';
import { isNodeVisible } from '../../utils';
import Tile from '../Tile';
import FallbackMessage from '../FallbackMessage';
import { LayoutContainer } from './styles';

class Layout extends PureComponent {
  static propTypes = {
    breadcrumbs: PropTypes.arrayOf(PropTypes.object),
    node: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
    level: PropTypes.oneOf([LAYOUT_LEVELS.module, LAYOUT_LEVELS.item]), // eslint-disable-line
  };

  static defaultProps = {
    breadcrumbs: [],
  };

  componentDidMount() {
    const { node } = this.props;
    document.title = node ? node.label : this.props.t('LPBD.breadcrumbs.home');
  }

  render() {
    const { node } = this.props;

    return (
      // eslint-disable-next-line react/jsx-fragments
      <React.Fragment>
        {this.props.breadcrumbs.map((breadcrumbNode, index) => (
          <BreadcrumbsItem key={index} to={breadcrumbNode?.uri || ''} weight={100 * index}>
            {breadcrumbNode?.label || ''}
          </BreadcrumbsItem>
        ))}
        {node && node.children && (
          <LayoutContainer>
            {node.children
              .filter(isNodeVisible)
              .map((child, idx) => (
                <Tile
                  key={idx}
                  node={child}
                  level={child?.children?.length && this.props.level}
                />
              ))}
          </LayoutContainer>
        )}
        {(!node || !node.children?.length) && <FallbackMessage />}
      </React.Fragment>
    );
  }
}

export default withTranslation()(Layout);
